import Backbone from 'backbone'
import _ from 'lodash'
import template from 'scoreboard/admin/connections/connection-label-and-owners.hbs'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import $ from 'jquery'
import user from 'scoreboard/components/user'

const ConnectionLabelAndOwners = Backbone.View.extend({

	className: 'connection-label-and-owners',

	tagName: 'form',

	template,

	/**
	 * The last step of each connection wizard, which is to choose a name for
	 * the import connection and set its owners.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Connection} options.model
	 */
	initialize(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render() {
		this.$el.empty().append(this.template({ title: this.options.title }))
		formHelper.writeToDom(this.model, this.el)

		this.renderLabelField()
		this.renderPrincipalPanel()

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})
		this.formView.start()
		return this
	},

	renderLabelField() {
		const el = this.$('[name=label]')
		this.labelField = new MarkedField({
			el,
			validator: requiredValidator
		}).render()
		if (this.model.get('type') === 'google-sheets') {
			el.prop('disabled', true)
		}
	},

	renderPrincipalPanel() {
		let currentPrincipals = this.model.get('owners') || []
		if (_.isEmpty(currentPrincipals) && this.model.isNew()) {
			currentPrincipals = [ user.principal ]
		}
		this.principalPanel = new PrincipalPanel({
			el: this.$('.principal-panel'),
			headingKey: 'common.owners',
			placeholderKey: 'admin.importConnections.addOwners',
			currentPrincipals
		}).render()
	},

	saveState() {
		_.extend(this.model.attributes, formHelper.readFromDom(this.el))
		this.model.set('owners', this.principalPanel.getPrincipals())
	},

	submit() {
		this.saveState()
		var isNew = this.options.model.isNew()
		return $.ajax({
			url: _.result(this.options.model, 'urlRoot'),
			method: isNew ? 'put' : 'post',
			data: JSON.stringify(this.options.model.attributes),
			success: function(connection) {
				// Connection response does not carry saved owner data from ui.
				// Append owners to connection object for rerender.
				connection['owners'] = this.model.get('owners')
				var action = isNew ? 'add' : 'edit'
				Backbone.trigger(action + ':import-connection', connection)
				this.trigger('done')
			}.bind(this)
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.labelField, this.principalPanel, this.formView], 'remove')
	}

})

export default ConnectionLabelAndOwners

ConnectionLabelAndOwners.__filename__ = 'admin/connections/connection-label-and-owners.js'
